import styled from 'styled-components';

export const Container = styled.div`
  width: 85%;
  min-height: ${({ Open }) => (Open ? '10rem' : '5.4rem')};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  background-color: ${({ Open }) => (Open ? '#CFF8E7' : '#fff')};

  border: ${({ Open }) =>
    Open ? '1.41135px solid #40e5a0' : '1.41135px solid #D4D6DA'};
  border-radius: 0.3rem;

  font-family: 'Sora';
  font-style: normal;

  z-index: ${({ Open }) => (Open ? 50 : 0)};
  cursor: pointer;
`;

export const Label = styled.span`
  margin-top: 0.4rem;
  width: 90%;
  font-weight: 400;
  font-size: 0.76rem;
  line-height: 0.95rem;
  color: #a9aeb4;
`;

export const ProName = styled.span`
  width: 90%;
  margin-top: 1.4rem;
  font-weight: 600;
  font-size: 0.96rem;
  line-height: 1.2rem;
  color: #212326;
`;

export const Extended = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  margin-top: 1rem;
  justify-content: center;

  span {
    display: flex;
    font-family: 'Sora';
    font-style: normal;
    font-weight: 600;
    font-size: 0.8rem;
    line-height: 1rem;
    text-align: center;
    color: #212326;
  }
`;
